import { render, staticRenderFns } from "./ClinicsModule.vue?vue&type=template&id=b0bb4a50"
import script from "./ClinicsModule.vue?vue&type=script&lang=js"
export * from "./ClinicsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports